import { createAction } from '@reduxjs/toolkit'

export clearGraph = createAction('graph/cleared')
export removeGraphEdge = createAction('graph/edgeRemoved')
export removeGraphEdges = createAction('graph/edgesRemoved')
export removeGraphNode = createAction('graph/nodeRemoved')
export removeGraphNodes = createAction('graph/nodesRemoved')
export setDevtoolsEnabled = createAction('graph/devtoolsEnabledSet')
export setGraphAddingEdge = createAction('graph/addingEdgeSet')
export setGraphColorPickerProps = createAction('graph/graphColorPickerPropsSet')
export setGraphCreatingEdge = createAction('graph/creatingEdgeSet')
export setGraphRenameRelationProps = createAction('graph/renameRelationPropsSet')
export setGraphEditingLabels = createAction('graph/editingLabelsSet')
export setGraphNodeView = createAction('graph/nodeViewSet')
export setGraphNodes = createAction('graph/graphNodesSet')
export setGraphShowingNode = createAction('graph/showingNodeSet')
export setSelectedGraphItems = createAction('graph/selectedGraphItemsSet')
export updateGraphNodes = createAction('graph/graphNodesUpdated')
export setSynthesizerEnabled = createAction('graph/synthesizerEnabled')
export setBPM = createAction('graph/setBPM')
export setIsEmbeddedView = createAction('graph/isEmbeddedView')
